import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Logo from "../../assets/images/logo.png";

const vCardData = [
  {
    slug: "F9D42P",
    name: "Riki Rusdian",
    organization: "PT Kencana eGlobal Projects",
    title: "Product Strategic Manager",
    email: "riki.rusdian@k-egp.com",
    mobile: "+62-85780325566",
    phone: "+62-21-39720881",
    website: "https://k-egp.com",
    address1: "Menara Pondok Indah lantai 2",
    address2: "Jl. Metro Pondok Indah kav II/BA No.2",
    address3: "Pondok Pinang, Kebayoran Lama",
    city: "Jakarta",
    country: "Indonesia",
    zip: "12310"
  },
  {
    slug: "B6WQFU",
    name: "Rasya Adiananto",
    organization: "PT Kencana eGlobal Projects",
    title: "Customer Support",
    email: "rasya.ananto@k-egp.com",
    mobile: "+62-82112498405",
    phone: "+62-21-39720881",
    website: "https://k-egp.com",
    address1: "Menara Pondok Indah lantai 2",
    address2: "Jl. Metro Pondok Indah kav II/BA No.2",
    address3: "Pondok Pinang, Kebayoran Lama",
    city: "Jakarta",
    country: "Indonesia",
    zip: "12310"
  },
  {
    slug: "KUQG5I",
    name: "Rudianto Wibowo",
    organization: "PT Kencana eGlobal Projects",
    title: "General Affair",
    email: "rudianto.wibowo@k-egp.com",
    mobile: "+62-81212194414",
    phone: "+62-21-39720881",
    website: "https://k-egp.com",
    address1: "Menara Pondok Indah lantai 2",
    address2: "Jl. Metro Pondok Indah kav II/BA No.2",
    address3: "Pondok Pinang, Kebayoran Lama",
    city: "Jakarta",
    country: "Indonesia",
    zip: "12310"
  },
  {
    slug: "HYGV91",
    name: "Leo Sompie",
    organization: "PT Kencana eGlobal Projects",
    title: "Sales Representative",
    email: "leo.sompie@yahoo.com",
    mobile: "+62-8114902987",
    phone: "+62-21-39720881",
    website: "https://k-egp.com",
    address1: "Menara Pondok Indah lantai 2",
    address2: "Jl. Metro Pondok Indah kav II/BA No.2",
    address3: "Pondok Pinang, Kebayoran Lama",
    city: "Jakarta",
    country: "Indonesia",
    zip: "12310"
  },
  {
    slug: "HX150B",
    name: "Fadjar Ananto",
    organization: "PT Kencana eGlobal Projects",
    title: "Chief Executive Officer",
    email: "fadjar.ananto@k-egp.com",
    mobile: "+62-8114900088",
    phone: "+62-21-39720881",
    website: "https://k-egp.com",
    address1: "Menara Pondok Indah lantai 2",
    address2: "Jl. Metro Pondok Indah kav II/BA No.2",
    address3: "Pondok Pinang, Kebayoran Lama",
    city: "Jakarta",
    country: "Indonesia",
    zip: "12310"
  },
  {
    slug: "B4SQZ3",
    name: "Muchtar Amien",
    organization: "PT Kencana eGlobal Projects",
    title: "Product Consultant",
    email: "muchtar.amien@k-egp.com",
    mobile: "+62-82116150006",
    phone: "+62-21-39720881",
    website: "https://k-egp.com",
    address1: "Menara Pondok Indah lantai 2",
    address2: "Jl. Metro Pondok Indah kav II/BA No.2",
    address3: "Pondok Pinang, Kebayoran Lama",
    city: "Jakarta",
    country: "Indonesia",
    zip: "12310"
  },
  {
    slug: "MSPC7T",
    name: "Wahyu Fathan Amin",
    organization: "PT Kencana eGlobal Projects",
    title: "Product Consultant",
    email: "wahyu.amin@k-egp.com",
    mobile: "+62-8114900088",
    phone: "+62-21-39720881",
    website: "https://k-egp.com",
    address1: "Menara Pondok Indah lantai 2",
    address2: "Jl. Metro Pondok Indah kav II/BA No.2",
    address3: "Pondok Pinang, Kebayoran Lama",
    city: "Jakarta",
    country: "Indonesia",
    zip: "12310"
  },
  {
    slug: "N7W2VF",
    name: "Chandra Adi Shiara",
    organization: "PT Kencana eGlobal Projects",
    title: "Product Consultant",
    email: "chandra.shiara@k-egp.com",
    mobile: "+62-82116150006",
    phone: "+62-21-39720881",
    website: "https://k-egp.com",
    address1: "Menara Pondok Indah lantai 2",
    address2: "Jl. Metro Pondok Indah kav II/BA No.2",
    address3: "Pondok Pinang, Kebayoran Lama",
    city: "Jakarta",
    country: "Indonesia",
    zip: "12310"
  },
  {
    slug: "RN86TD",
    name: "Taufiq Djudien",
    organization: "PT Kencana eGlobal Projects",
    title: "VP Business Development",
    email: "taufiq.djudien@k-egp.com",
    mobile: "+62-81311166759",
    phone: "+62-21-39720881",
    website: "https://k-egp.com",
    address1: "Menara Pondok Indah lantai 2",
    address2: "Jl. Metro Pondok Indah kav II/BA No.2",
    address3: "Pondok Pinang, Kebayoran Lama",
    city: "Jakarta",
    country: "Indonesia",
    zip: "12310"
  },
  {
    slug: "Q824RV",
    name: "Mus Afandi",
    organization: "PT Kencana eGlobal Projects",
    title: "Training Advisor",
    email: "mus.afandi@k-egp.com",
    mobile: "+62-85250661932",
    phone: "+62-21-39720881",
    website: "https://k-egp.com",
    address1: "Menara Pondok Indah lantai 2",
    address2: "Jl. Metro Pondok Indah kav II/BA No.2",
    address3: "Pondok Pinang, Kebayoran Lama",
    city: "Jakarta",
    country: "Indonesia",
    zip: "12310"
  },
  {
    slug: "M7ZS4P",
    name: "Sarah Ayu Nanda",
    organization: "PT Kencana eGlobal Projects",
    title: "Front-End Developer",
    email: "sarah.nanda@k-egp.com",
    mobile: "+62-81328484322",
    phone: "+62-21-39720881",
    website: "https://k-egp.com",
    address1: "Menara Pondok Indah lantai 2",
    address2: "Jl. Metro Pondok Indah kav II/BA No.2",
    address3: "Pondok Pinang, Kebayoran Lama",
    city: "Jakarta",
    country: "Indonesia",
    zip: "12310"
  },
]

const OFFICE_ADDRESS = [
  {
    title: "Jakarta Office",
    link: "https://maps.app.goo.gl/73APCtv8snqhdDsS6",
    details: [
      "Menara Pondok Indah lantai 2",
      "JI. Metro Pondok Indah kav Il/BA No.2",
      "RT.3/RW.14, Pondok Pinang, Kebayoran Lama",
      "Jakarta 12310, Indonesia",
    ]
  },
  {
    title: "Balikpapan Office",
    link: "https://maps.app.goo.gl/Kjar3CTbgLw1V9Qc9",
    details: [
      "Komplek Ruko Borneo Paradiso Maple D No. 1",
      "Balikpapan, Kalimantan Timur, Indonesia",
    ]
  }
]

const VCard = () => {
  const navigate = useNavigate()
  const { slug } = useParams()
  const vCard = vCardData.find((card) => card.slug === slug)

  const downloadVCard = () => {
    const vcfData = `
BEGIN:VCARD
VERSION:3.0
FN:${vCard.name}
ORG:${vCard.organization}
TITLE:${vCard.title}
EMAIL:${vCard.email}
TEL;TYPE=CELL:${vCard.mobile}
TEL;TYPE=WORK,VOICE:${vCard.phone}
ADR;TYPE=WORK:;;${vCard.address1};${vCard.city};${vCard.zip};${vCard.country}
ADR;TYPE=WORK:;;${OFFICE_ADDRESS[1].details[0]};${OFFICE_ADDRESS[1].details[1]}
URL:${vCard.website}
END:VCARD
    `;
    const blob = new Blob([vcfData], { type: 'text/vcard' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${vCard.name}.vcf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    if (!vCard) navigate("/")
  }, [vCard, navigate])
  if (!vCard) return null

  return (
    <section className="contact__page p_relative see__pad">
      <div className="auto-container">
        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-12">
            <h1>{vCard.name}</h1>
            <h4>{vCard.title}</h4>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-12 pt-20 pb-10">
            <img src={Logo} alt="" className="logo_img" />
          </div>
        </div>

        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-12">
            <h5><strong>{vCard.organization}</strong></h5>

            {/* <div className='account-info-wrapper mt-20'>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width={24} height={24}>
                <path fillRule="evenodd" d="M12 2a7 7 0 00-7 7c0 4.418 7 13 7 13s7-8.582 7-13a7 7 0 00-7-7zm0 9.75a2.75 2.75 0 100-5.5 2.75 2.75 0 000 5.5z" clipRule="evenodd" />
              </svg>
              {vCard.address1}
            </div> */}

            {/* new address */}
            <div className='account-info-wrapper mt-20' style={{ gap: "8px", display: "flex", flexDirection: "column" }}>
              {OFFICE_ADDRESS.map((office, index) => (
                <div key={index} className="col-lg-12 col-md-12 col-sm-12">
                  <div className="account-info-wrapper">
                    {index === 0 ?
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width={24} height={24}>
                        <path fillRule="evenodd" d="M12 2a7 7 0 00-7 7c0 4.418 7 13 7 13s7-8.582 7-13a7 7 0 00-7-7zm0 9.75a2.75 2.75 0 100-5.5 2.75 2.75 0 000 5.5z" clipRule="evenodd" />
                      </svg>
                      :
                      <div style={{ width: "24px" }}>&nbsp;</div>
                    }
                    <Link to={office.link} target="_blank" rel="noopener noreferrer" className="fw-semibold">{office.title}</Link>
                  </div>
                  {office.details.map((detail, detailIndex) => (
                    <div key={detailIndex} className="account-info-wrapper">
                      <div style={{ width: "24px" }}>&nbsp;</div>
                      {detail}
                    </div>
                  ))}
                </div>
              ))}
            </div>

            {/* old address */}
            {/* <p>
              <div className='account-info-wrapper'>
                <div style={{ width: "24px" }}>&nbsp;</div>
                {vCard.address2}
              </div>
            </p>
            <p>
              <div className='account-info-wrapper'>
                <div style={{ width: "24px" }}>&nbsp;</div>
                {vCard.address3}
              </div>
            </p>
            <p>
              <div className='account-info-wrapper'>
                <div style={{ width: "24px" }}>&nbsp;</div>
                {vCard.city}, {vCard.zip}, {vCard.country}
              </div>
            </p> */}

            <div className='account-info-wrapper' style={{ marginTop: "12px" }}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width={24} height={24}>
                <path fillRule="evenodd" d="M1.5 4.5a3 3 0 0 1 3-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 0 1-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 0 0 6.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 0 1 1.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 0 1-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5Z" clipRule="evenodd" />
              </svg>
              <Link to={"tel:" + vCard.phone}>{vCard.phone}</Link>
            </div>

            <div className='account-info-wrapper' style={{ marginTop: "12px" }}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width={24} height={24}>
                <path fillRule="evenodd" d="M6 1.5a1.5 1.5 0 0 1 1.5-1.5h9a1.5 1.5 0 0 1 1.5 1.5v21a1.5 1.5 0 0 1-1.5 1.5h-9a1.5 1.5 0 0 1-1.5-1.5v-21zM12 21a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zM15 2h-6v2h6V2z" clipRule="evenodd" />
              </svg>
              <Link to={"tel:" + vCard.mobile}>{vCard.mobile}</Link>
            </div>

            <div className='account-info-wrapper' style={{ marginTop: "12px" }}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width={24} height={24}>
                <path d="M1.5 8.67v8.58a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V8.67l-8.928 5.493a3 3 0 0 1-3.144 0L1.5 8.67Z" />
                <path d="M22.5 6.908V6.75a3 3 0 0 0-3-3h-15a3 3 0 0 0-3 3v.158l9.714 5.978a1.5 1.5 0 0 0 1.572 0L22.5 6.908Z" />
              </svg>
              <Link to={"mailto:" + vCard.email}>{vCard.email}</Link>
            </div>

            <div className='account-info-wrapper' style={{ marginTop: "12px" }}>
              <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M4.37 7.657c2.063.528 2.396 2.806 3.202 3.87 1.07 1.413 2.075 1.228 3.192 2.644 1.805 2.289 1.312 5.705 1.312 6.705M20 15h-1a4 4 0 0 0-4 4v1M8.587 3.992c0 .822.112 1.886 1.515 2.58 1.402.693 2.918.351 2.918 2.334 0 .276 0 2.008 1.972 2.008 2.026.031 2.026-1.678 2.026-2.008 0-.65.527-.9 1.177-.9H20M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
              </svg>
              <Link to="mailto:info@k-egp.com">{vCard.website}</Link>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-12 mt-30">
            <button className="theme-btn theme-btn-one" onClick={downloadVCard}>
              Download vCard
            </button>
          </div>
        </div>
      </div>

    </section>
  )
}

export default VCard

